import { createStore } from "vuex";
import createPersistedState from 'vuex-persistedstate';
import utils from '../utils/utils';
export default createStore({
  state: {
    permission: utils.$localStorage.getLocalStorage('permission') || null,
    authorInfo: () => {
      let authorInfo = utils.$localStorage.getLocalStorage('authorInfo');
      if (authorInfo) {
        authorInfo = JSON.parse(authorInfo);
      } else {
        authorInfo = null;
      }
      return authorInfo;
    },
    cacheRouterList: utils.$localStorage.getLocalStorage('cacheRouterList') || [],

    // 缓存路由
    KEEP_LIVE_ROUTE_NAMES: []
  },
  mutations: {
    /**any
     * 设置路由缓存
     */
    SET_ROUTE_NAMES: (state: any, name) => {
      if (!state.KEEP_LIVE_ROUTE_NAMES.includes(name)) {
        state.KEEP_LIVE_ROUTE_NAMES.push(name)
      }
      // 超过限制清除第一个
      if (state.KEEP_LIVE_ROUTE_NAMES.length > 10) {
        state.KEEP_LIVE_ROUTE_NAMES.unshift()
      }
    },

    /**
     * 清除路由缓存
     */
    CLEAR_ROUTE(state: any, name?) {
      if (state.KEEP_LIVE_ROUTE_NAMES.includes(name || "")) {
        state.KEEP_LIVE_ROUTE_NAMES.splice(state.KEEP_LIVE_ROUTE_NAMES.indexOf(name), 1);
        state.KEEP_LIVE_ROUTE_NAMES=[...state.KEEP_LIVE_ROUTE_NAMES]
        return;
      }
      state.KEEP_LIVE_ROUTE_NAMES = []
    },

    // 设置用户信息缓存
    setauthorInfo(state, data) {
      utils.$localStorage.addLocalStorage('authorInfo', JSON.stringify(data));
      state.authorInfo = data;
    },
    // 设置用户拥有的权限
    setPermission(state, data) {
      utils.$localStorage.addLocalStorage('permission', JSON.stringify(data));
      state.permission = data;
    },
    // 设置缓存路由
    setCacheRouter(state, data) {
      utils.$localStorage.addLocalStorage('cacheRouterList', JSON.stringify(data));
      state.cacheRouterList = data;
    },
    // 清除缓存路由
    clearCacheRouter(state, data) {
      state.cacheRouterList = data;
      utils.$localStorage.removeLocalStorage('cacheRouterList');
    }
  },
  actions: {},
  modules: {},
  plugins: [
    createPersistedState({
      reducer(state) {
        return {
          permission: state.permission,
          authorInfo: state.authorInfo,
          cacheRouterList: state.cacheRouterList
        }
      }
    })
  ]
});
